import { createAction, props } from '@ngrx/store';
import { Employee, EmployeeGroup } from '@fc-core';
import { FilterItem } from '@fc-vehicles/components/shared/vehicle-filter/vehicles-filter.component';
import { HttpErrorResponse } from '@angular/common/http';

import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

// todo we need to split this into the different stores
export const loadEmployee = createAction(
  '[Employee/API] Load Employee',
  props<{ id: string }>(),
);
export const loadEmployeeSuccess = createAction(
  '[Employee/API] Load Employee Success',
  props<{ employee: Employee }>(),
);
export const loadCurrentEmployee = createAction(
  '[Employee/API] Get Current Employee',
);
export const loadCurrentEmployeeSuccess = createAction(
  '[Employee/API] Get Current Employee Success',
  props<{ employee: Employee }>(),
);

export const archiveEmployee = createAction(
  '[Employee/API] Archive Employee',
  props<{ employeeId: string }>(),
);
export const unarchiveEmployee = createAction(
  '[Employee/API] Unarchive Employee',
  props<{ employeeId: string }>(),
);
export const unarchiveEmployeeSuccess = createAction(
  '[Employee/API] Unarchive Employee Success',
  props<{ employeeId: string }>(),
);
export const archiveEmployeeSuccess = createAction(
  '[Employee/API] Archive Employee Success',
  props<{ employeeId: string }>(),
);
export const employeeAPIError = createAction(
  '[Employee/API] Employees API Error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadEmployees = createAction('[Employee/API] Load Employees');
export const loadEmployeesSuccess = createAction(
  '[Employee/API] Load Employees Success',
  props<{ users: Employee[]; count: number }>(),
);
export const addEmployeeSuccess = createAction(
  '[Employee/API] Add Employee Success',
  props<{ employee: Employee }>(),
);

export const updateEmployee = createAction(
  '[Employee/API] Update Employee',
  props<{ id: string; changes: { [key: string]: any } }>(),
);
export const enableOperator = createAction(
  '[Employee/API] Enable operator',
  props<{ employee: Employee }>(),
);
export const enableOperatorSuccess = createAction(
  '[Employee/API] Enable operatorSuccess',
  props<{ employee: Employee }>(),
);
export const disableOperator = createAction(
  '[Employee/API] Disable operator',
  props<{ employeeId: string; operatorId: number }>(),
);
export const disableOperatorSuccess = createAction(
  '[Employee/API] Disable operatorSuccess',
  props<{ employeeId: string }>(),
);
export const enableAdmin = createAction(
  '[Employee/API] Enable admin',
  props<{ employeeId: string }>(),
);
export const enableAdminSuccess = createAction(
  '[Employee/API] Enable adminSuccess',
  props<{ employee: Employee }>(),
);
export const disableAdmin = createAction(
  '[Employee/API] Disable admin',
  props<{ employeeId: string }>(),
);
export const disableAdminSuccess = createAction(
  '[Employee/API] Disable adminSuccess',
  props<{ employee: Employee }>(),
);
export const updateEmployeeSuccess = createAction(
  '[Employee/API] Update Employee Success',
  props<{ employee: Employee }>(),
);

export const resendPassword = createAction(
  '[Employee] Resend password',
  props<{ email: string }>(),
);
export const resendPasswordSuccess = createAction(
  '[Employee] Resend password Success',
  props<{ email: string }>(),
);

// USERS FILTER ACTIONS
export const setEmployeeSortBy = createAction(
  '[Employee] Set Employee SortBy',
  props<{ sortBy: SortBy }>(),
);
export const setSearchText = createAction(
  '[Employee] Set Search Text',
  props<{ searchText: string }>(),
);

export const selectUserGroupFilter = createAction(
  '[Employee] Select user group Filter',
  props<{ userGroup: EmployeeGroup }>(),
);

export const setEmployeeFilter = createAction(
  '[EmployeeFilters] Set Employee Filter',
  props<{ filterItem: FilterItem }>(),
);
export const resetEmployeeFilters = createAction(
  '[EmployeeFilters] Reset Employee Filter',
);

export const setManyEmployeeFilters = createAction(
  '[EmployeeFilters] Set Many Employee Filters',
  props<{ filters: FilterItem[] }>(),
);
